<template>
  <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
    <div class="contacts-9 py-lg-5 py-md-4">
      <div class="container">
        <div class="header-sec text-center mb-5">
          <br/>
          <h1 class="title-w3l">
            Partners
          </h1>
        </div>
        <div class="contactct-fm map-content-9">
          <br/>
          <div class="clearfix"></div>
          <p>We assist the following companies in getting quality leads for their business.</p><br/>
          <br/>
        </div>
        <br/>
        <div class="row">
          <div class="col-md-4" v-if="data.sequences != null" v-for="(sequence, index) in data.sequences" :key="index">
            <NuxtLink external :to="sequence.link" target="_blank" rel="nofollow" >
              <div class="card blue-background" :title="sequence.description">
                <div class="card-body">
                  <h5 class="card-title white-text">{{ sequence.name }}</h5>
                  <p class="card-text white-text">{{ sequence.link }}</p><br/>
                  <p class="card-text white-text ellipsis">{{ sequence.description }}</p>
                </div>
              </div>
            </NuxtLink>
            <br/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Log from "../../Common/Client/Log";
import Info from "../../Common/Client/Info";
import Globals from "../global";
import type {NuxtApp} from "#app";

const headers = useRequestHeaders(['cookie'])
const route = useRoute();
function log(message: string, isInfo: boolean = true) {
  Log.log(message, route.path, isInfo, headers);
}

const {
  data,
} = await useAsyncData(async function (ctx?: NuxtApp | undefined): Promise<unknown> {
  try {
    const sequenceResponse = await $fetch(`/api/sequence/all`, {method: "GET", headers});
    return {sequences: sequenceResponse};
  } catch (ex) {
    log("Error occurred while getting partners");
    log(Info.prettifyIfPossible(ex), false);
    Log.reportError(headers);
  }
});


useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – View our partners`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Check out businesses that use ForumLeadsFinder to find accurate leads for them.`
    }
  ]
});
</script>


<style scoped>
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.blue-background:hover {
  background: blue;
}

.blue-background:hover .white-text {
  color: white;
}
</style>